import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {UrlService} from '../url.service';

@Injectable()
export class EnrollmentService {
    private readonly BASE_URL: string;
    private readonly TAGS_URL: string;

    constructor(private http: HttpClient,
                private urlService: UrlService) {
        this.BASE_URL = this.urlService.getBackendUrl() + 'data/clients';
        this.TAGS_URL = this.urlService.getBackendUrl() + 'data/tags';
    }

    // The enrollment types are the child tags of the configured enrollments root tag.
    getEnrollmentTypes() {
        return this.http.get(this.TAGS_URL + '/forEnrollments');
    }

    // Returns true only if the per-type configuration explicitly allows overlapping enrollments.
    // Default (no config for the type) is that overlaps are NOT allowed.
    getOverlapAllowedForCode(tagCode, enrollmentsConfiguration) {
        if ((enrollmentsConfiguration) && (enrollmentsConfiguration.configurations)
            && (enrollmentsConfiguration.configurations[tagCode])) {
            if (enrollmentsConfiguration.configurations[tagCode].overlapAllowed) {
                return enrollmentsConfiguration.configurations[tagCode].overlapAllowed;
            }
        }
        return false;  // default behavior -- overlaps not allowed.
    }

    // Returns false only if the per-type configuration explicitly sets userManageable to false.
    // Default (no config for the type, or the flag unset) is TRUE -- the type is user-manageable.
    // UI gating only; not enforced server-side.
    getUserManageableForCode(tagCode, enrollmentsConfiguration) {
        if ((enrollmentsConfiguration) && (enrollmentsConfiguration.configurations)
            && (enrollmentsConfiguration.configurations[tagCode])) {
            if (enrollmentsConfiguration.configurations[tagCode].userManageable === false) {
                return false;
            }
        }
        return true;  // default behavior -- type is user-manageable.
    }

    // The list endpoint paginates (default limit 20). Pass a high limit to retrieve them all for display.
    getEnrollments(clientId, limit?) {
        let params: HttpParams = new HttpParams();
        if (limit != null) {
            params = params.append('limit', limit);
        }
        return this.http.get(this.BASE_URL + '/' + clientId + '/enrollments', {params});
    }

    getEnrollment(clientId, enrollmentId) {
        return this.http.get(this.BASE_URL + '/' + clientId + '/enrollments/' + enrollmentId);
    }

    createEnrollment(clientId, enrollment) {
        return this.http.post(this.BASE_URL + '/' + clientId + '/enrollments', enrollment);
    }

    saveEnrollment(clientId, enrollmentId, enrollment) {
        return this.http.put(this.BASE_URL + '/' + clientId + '/enrollments/' + enrollmentId, enrollment);
    }

    removeEnrollment(clientId, enrollmentId) {
        return this.http.delete(this.BASE_URL + '/' + clientId + '/enrollments/' + enrollmentId);
    }
}
